import { NormalizedUnitValue } from '@/helpers/unit-formatter/shared/types';
import { durationToSeconds } from '@/helpers/unit-formatter/shared/utils';

import { transformTime } from './transform-time';

/**
 * Transforms duration values from H:MM format to time units via a seconds pivot.
 */
export const transformDuration = (
  unitValue: NormalizedUnitValue,
  newUnits?: string
): NormalizedUnitValue => {
  const normalizedTarget = newUnits?.toLowerCase();
  if (!normalizedTarget || !['sec', 'min', 'hrs'].includes(normalizedTarget)) {
    return unitValue;
  }

  const seconds = durationToSeconds(unitValue.value);
  if (seconds == null) return unitValue;

  return transformTime({ value: seconds, units: 'sec' }, newUnits);
};
